export { StyledError } from "./StyledError";
